import b2c from '../../external/plans/b2c.vue'
import b2b from '../../external/plans/b2b.vue'
import vpo from '../../external/plans/vpo.vue'
export default {
  props:['type'],
  components:{b2c, b2b, vpo}
}



// WEBPACK FOOTER //
// ./src/pages/account/contract/choose-new-plan.js